<template>
  <div class="menu">
    <ul class="list-primary">
      <li v-for="menuPage in menuValid" :key="menuPage.link">
        <a class="list-primary" :href="menuPage.link"> {{ menuPage.name }}</a>
        <ul class="sub" v-if="menuPage.sub.length > 0">
          <li v-for="(subMenuPage, index2) in menuPage.sub" :key="index2">
            <a :href="subMenuPage.link">{{ subMenuPage.name }} </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menu: Array,
  },
  computed: {
    menuValid() {
      const copyMenu = structuredClone(this.menu);
      // eslint-disable-next-line no-unused-vars
      for (let i = 0; i < copyMenu.length; i++) {
        if (copyMenu[i].sub.length > 0) {
          copyMenu[i].sub = this.checkMenu(copyMenu[i].sub);
        }
        if (
          !(copyMenu[i].perm === "" || this.checkPermission(copyMenu[i].perm))
        ) {
          copyMenu.splice(i, 1);
        }
      }
      return copyMenu;
    },
    perm() {
      return this.$store.getters.permissions || [];
    },
  },
  methods: {
    checkMenu(menu) {
      const newMenu = [];
      // eslint-disable-next-line no-unused-vars
      for (const item of menu) {
        if (item.sub.length > 0) {
          item.sub = this.checkMenu(item.sub);
        }
        if (item.perm === "" || this.checkPermission(item.perm)) {
          newMenu.push(item);
        }
      }
      return newMenu;
    },
    checkPermission(per) {
      return this.perm?.indexOf(per) !== -1;
    },
  },
};
</script>

<style scoped>
div.menu a {
  text-decoration: none;
  color: black;
  display: block;
  background: #8cabc5;
}

div.menu ul {
  display: -webkit-inline-box;
  list-style: none;
  position: relative;
  text-align: left;
  margin: 0px;
  padding: 0px;
}

div.menu li {
  float: left;
  min-width: 100px;
}

div.menu ul.list-primary li a.list-primary {
  display: block;
  padding: 5px 10px;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid #787978;
  border-bottom: none;
  text-align: center;
}

div.menu ul.sub {
  position: absolute;
  z-index: 200;
  display: none;
  padding: 0px;
}

div.menu ul.sub li {
  float: none;
  margin: 0;
}

div.menu ul.sub li a {
  border-bottom: 2px dotted #ccc;
  border-right: none;
  color: #000;
  padding: 10px 20px;
}

div.menu ul.sub li:last-child a {
  border-bottom: none;
}

div.menu ul.list-primary li:hover ul {
  display: block;
}

div.menu ul.list-primary li:hover a {
  /* background: #008500; */
  background: #7792a8;
  color: #000;
}

div.menu ul.sub li:hover > a {
  color: #000;
  background: #deb887;
}

div.menu ul.sub li:last-child > a {
  border-radius: 0px 0px 10px 10px;
}
</style>
